export default "__VITE_ASSET__CEsytnDJ__"